import { useRef } from "react";

// Horizontal swipe detection for touch screens. Ignores vertical scrolling
// gestures and taps; calls onLeft / onRight once per qualifying swipe.
export default function useSwipe({ onLeft, onRight, threshold = 48 }) {
  const start = useRef(null);
  const swiped = useRef(false);

  const onTouchStart = (e) => {
    const t = e.touches[0];
    start.current = { x: t.clientX, y: t.clientY };
    swiped.current = false;
  };

  const onTouchMove = (e) => {
    if (!start.current || swiped.current) return;
    const t = e.touches[0];
    const dx = t.clientX - start.current.x;
    const dy = t.clientY - start.current.y;
    if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy) * 1.4) return;
    swiped.current = true;
    if (dx < 0) onLeft?.(); else onRight?.();
  };

  const onTouchEnd = () => { start.current = null; };

  // Suppress the click that follows a swipe so the frame doesn't open.
  const onClickCapture = (e) => {
    if (swiped.current) { e.stopPropagation(); e.preventDefault(); swiped.current = false; }
  };

  return { onTouchStart, onTouchMove, onTouchEnd, onClickCapture };
}
